<template>
  <footer
    class="w-full flex justify-center items-start self-stretch text-text text-center font-sans text-2xs font-medium leading-5 px-1 mt-auto"
  >
    <nav class="flex flex-col large-desktop:flex-row justify-center gap-8">
      <RouterLink
        :to="{
          name: RouteNames.PrivacyPolicy,
        }"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t("footer.privacyPolicy") }}</RouterLink
      >
      <RouterLink
        :to="{
          name: RouteNames.TermsOfService,
        }"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t("footer.termsOfService") }}</RouterLink
      >

      <RouterLink
        :to="{
          name: RouteNames.AccessibilityStatement,
        }"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t("footer.accessibility") }}</RouterLink
      >

      <button @click="appStore.showCookieSettings = true">
        {{ $t("footer.cookieSettings") }}
      </button>

      <RouterLink
        v-if="userStore.isAuthenticated"
        :to="{
          name: RouteNames.ProfilePrivacy,
          params: { channel: channelStore.channelSlug },
        }"
        >{{ $t("footer.doNotSell") }}</RouterLink
      >
    </nav>
  </footer>
</template>

<script setup lang="ts">
import { RouteNames } from "@/router/app.router";
import { useAppStore } from "@/stores/app.store";
import { useUserStore } from "@/stores/user.store";
import { useChannelStore } from "@/stores/channel.store";
import { RouterLink } from "vue-router";

const appStore = useAppStore();
const userStore = useUserStore();
const channelStore = useChannelStore();
</script>
